import { Button } from "@mui/material";
import styled from "styled-components";

const RemoveButton = styled(Button)`
  padding: 0;
`;

export default RemoveButton;
